<script setup>
const props = defineProps({
  handshakeData: {
    type: Object,
    required: true,
  },
});
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <div id="wizard" class="container py-4">
    <div v-if="handshakeData.errors" class="alert alert-danger">
      {{ handshakeData.errors }}
    </div>

    <a role="button" :href="handshakeData.return_url" class="button button_secondary">Go back</a>
  </div>
</template>
